module.exports = __webpack_public_path__ + "img/jboard_icon-40.f0fd3cca.png";